import React, { useState } from "react";
import PropTypes from "prop-types";

export default function SocialEmbedCard({ youtube, instagram, loading }) {
  const tabs = [
    youtube?.enabled && {
      key: "youtube",
      label: youtube.title || "Video",
      embedUrl: youtube.embedUrl,
    },
    instagram?.enabled && {
      key: "instagram",
      label: instagram.title || "Instagram",
      embedUrl: instagram.embedUrl,
    },
  ].filter(Boolean);

  const [active, setActive] = useState(tabs[0]?.key);

  if (loading) {
    return (
      <div className="card-soft p-4 features-card">
        <div className="skeleton w-100 h-100" />
      </div>
    );
  }

  if (tabs.length === 0) {
    return (
      <div className="card-soft p-4 features-card d-flex align-items-center justify-content-center">
        <p className="text-muted mb-0" style={{ fontSize: 13 }}>
          No videos available right now.
        </p>
      </div>
    );
  }

  const activeTab = tabs.find((t) => t.key === active) || tabs[0];

  return (
    <div className="card-soft p-4 features-card d-flex flex-column">
      <div className="d-flex gap-2 mb-3 d-none ">
        {tabs.map((t) => (
          <button
            key={t.key}
            type="button"
            onClick={() => setActive(t.key)}
            className={`embed-tab-btn ${activeTab.key === t.key ? "active" : ""}`}
          >
            {t.label}
          </button>
        ))}
      </div>

      <div className="embed-frame-wrap flex-grow-1">
        <iframe
          key={activeTab.key}
          src={activeTab.embedUrl}
          title={activeTab.label}
          className="embed-frame"
          frameBorder="0"
          allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
          allowFullScreen
        />
      </div>
    </div>
  );
}

SocialEmbedCard.propTypes = {
  youtube: PropTypes.shape({
    enabled: PropTypes.bool,
    title: PropTypes.string,
    embedUrl: PropTypes.string,
  }),
  instagram: PropTypes.shape({
    enabled: PropTypes.bool,
    title: PropTypes.string,
    embedUrl: PropTypes.string,
  }),
  loading: PropTypes.bool,
};
